<template>
  <div>
    <div
      id="example-menu"
      class="top-bar kal-navigation-bar z-10 elevation-1"
      style="

      position: fixed;
      background: transparent;
      z-index: 0;
      width: 0;
      padding: 1px;
      padding: 6px;
      box-shadow: -10px -2px 7px 4px rgba(64, 64, 64, 0.07) !important;
      display:none;
  "
    ></div>
    <div class="top-bar kal-navigation-bar z-10 elevation-1" id="example-menu">
      <div class="bootstrap-wrapper">
        <div class="container w-100 m-0">
          <div class="row">
            <div class="top-bar-left col-md-10">
              <ul class="dropdown menu">
                <li
                  class="menu-text logo pt-0"
                  style="width: var(--width-aside);"
                >
                  <router-link to="/dashboard/analytics">
                    <img src="@/assets/images/logo.png" />
                  </router-link>
                </li>
                <li>
                  <router-link
                    to="/dashboard/books"
                    v-slot="{ href, route, navigate, isActive }"
                  >
                    <a
                      class="kal-navigation-link"
                      :class="[isActive && 'kal-navigation-link__active']"
                      :href="href"
                      @click="navigate"
                    >
                      <!-- <unicon name="book-open" :width="40" :height="40" class="w-75" :fill="secCol"></unicon> -->
                      <img
                        class="image-item"
                        src="@/assets/images/Componente 43 – 1.svg"
                      />
                      <span>{{ $t("books") }}</span>
                    </a>
                  </router-link>
                </li>
                <li>
                  <router-link
                    to="/dashboard/challenges"
                    v-slot="{ href, route, navigate, isActive }"
                  >
                    <a
                      class="kal-navigation-link"
                      :class="[isActive && 'kal-navigation-link__active']"
                      :href="href"
                      @click="navigate"
                    >
                      <!-- <unicon name="dumbbell" :width="40" :height="40" :fill="secCol"></unicon> -->
                      <img
                        class="image-item"
                        src="@/assets/images/Componente 45 – 1.svg"
                      />
                      <span>{{ $t("challenges") }}</span>
                    </a>
                  </router-link>
                </li>
                <li>
                  <router-link
                    to="/dashboard/messages"
                    v-slot="{ href, route, navigate, isActive }"
                  >
                    <a
                      class="kal-navigation-link"
                      :class="[isActive && 'kal-navigation-link__active']"
                      :href="href"
                      @click="navigate"
                    >
                      <!-- <unicon name="envelope-alt" :width="40" :height="40" :fill="secCol"></unicon> -->
                      <img
                        class="image-item"
                        src="@/assets/images/Componente 48 – 1.svg"
                      />
                      <span>{{ $t("messages") }}</span>
                    </a>
                  </router-link>
                </li>
                <li>
                  <router-link
                    to="/dashboard/resources"
                    v-slot="{ href, route, navigate, isActive }"
                  >
                    <a
                      class="kal-navigation-link"
                      :class="[isActive && 'kal-navigation-link__active']"
                      :href="href"
                      @click="navigate"
                    >
                      <!-- <unicon name="cloud-share" :width="40" :height="40" :fill="secCol"></unicon> -->
                      <img
                        class="image-item"
                        src="@/assets/images/Componente 46 – 1.svg"
                      />

                      <span>{{ $t("resources") }}</span>
                    </a>
                  </router-link>
                </li>
                <li>
                  <router-link
                    to="/dashboard/analytics/reports"
                    v-slot="{ href, route, navigate, isActive }"
                  >
                    <a
                      class="kal-navigation-link"
                      :class="[isActive && 'kal-navigation-link__active']"
                      :href="href"
                      @click="navigate"
                    >
                      <!-- <unicon name="chart-line" :width="40" :height="40" :fill="secCol"></unicon> -->
                      <img
                        class="image-item"
                        src="@/assets/images/Componente 44 – 1.svg"
                      />

                      <span>{{ $t("analytics") }}</span>
                    </a>
                  </router-link>
                </li>
              </ul>
            </div>
            <div class="tree-menu col-2">
              <div class="mt-3">
                <dropdown :class-name="'tree-menu'" :is-icon="false">
                  <template slot="btn">
                    <i class="fas fa-bars h1"></i>
                  </template>
                  <template slot="body">
                    <tree-menu
                      :text="item.text"
                      :children="item.children"
                      :link="item.link"
                      v-for="(item, i) in menu"
                      :key="i"
                    >
                    </tree-menu>
                  </template>
                </dropdown>
              </div>
            </div>
            <div class="center-logo col-6">
              <img src="@/assets/images/logo.png" />
            </div>
            <div class="top-bar-right col col-md-2">
              <ul class="menu">
                <li class="float-right">
                  <a @click="toggleOffCanvas(true)">
                    <div
                      class="kal-navigation-link kal-navigation-link__avatar"
                      style="position: absolute; right: 0px;"
                    >
                      <unicon
                        name="user-circle"
                        width="70"
                        height="70"
                        :fill="grayCol"
                        v-if="userData && !userData.avatar"
                      />
                      <img
                        width="70"
                        height="70"
                        :src="
                          require(`@/assets/avatar/Avatar ${userData.avatar}/Avatar-${userData.avatar}.gif`)
                        "
                        class="avatar-img transition-all"
                        v-if="userData && userData.avatar"
                        id="profileAvatar"
                      />
                      <div
                        v-if="quantiyPendingReports > 0"
                        class="badge badge-danger position-absolute mt-4 mx-3 p-2 rounded d-flex justify-content-center align-items-center"
                      >
                        <span class="font-2-em">{{
                          quantiyPendingReports
                        }}</span>
                      </div>
                    </div>
                    <div style="position: absolute; top: 33px; right: 68px;">
                      <span class="dots dots-vertical"></span>
                    </div>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";
import Dropdown from "bp-vuejs-dropdown";
import TreeMenu from "@/components/TreeMenu";

export default {
  name: "Navbar",
  components: {
    Dropdown,
    TreeMenu,
  },
  mounted() {
    setInterval(() => {
      const profileAvtar = document.getElementById("profileAvatar");
      if (profileAvtar) {
        profileAvtar.setAttribute(
          "src",
          document.getElementById("profileAvatar").getAttribute("src")
        );
      }
    }, 6000);
  },
  data() {
    let { secCol, grayCol } = this.$store.getters;

    return {
      secCol,
      grayCol,
    };
  },
  computed: {
    ...mapState(["menu", "userData"]),
    ...mapState({
      quantiyPendingReports: state => {
        if (
          state.userData &&
          state.userData.pendingReportDTO &&
          state.userData.pendingReportDTO.pendingReports
        )
          return state.userData.pendingReportDTO.pendingReports.length;
        else return null;
      },
    }),
  },
  methods: {
    ...mapMutations(["toggleOffCanvas"]),
  },
};
</script>

<style lang="scss" scoped>
.badge,
.badge.primary {
  background: #ff2323;
  color: #fefefe;
}

#example-menu {
  margin: 0 10%;
  width: 80%;
}
a:hover {
  text-decoration: none !important;
}

.image-item {
  border-radius: 0 !important;
  width: 100%;
  line-height: 0px;
  max-height: 5vh;
}

.tree-menu {
  display: none;
}

.logo {
  width: 180px;
  min-width: 180px;
}

.center-logo {
  display: none;
}

@media print, screen and (max-width: 576px) {
  #example-menu {
    margin: 0;
    width: 100%;
  }
}

@media print, screen and (max-width: 1070px) {
  .top-bar-left {
    display: none;
  }
  .tree-menu,
  .center-logo {
    display: block;
  }
}

@media (min-width: 1200px) {
  .bootstrap-wrapper .container,
  .bootstrap-wrapper .container .row {
    max-width: 100%;
  }
}

.top-bar.kal-navigation-bar {
  min-height: 100px;
}
</style>
